export class SalesforceApiError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "SalesforceApiError";
  }
}
